import { TextInfoField } from "#common/Texto"
import Box from "@mui/material/Box"
import Grid2 from "@mui/material/Unstable_Grid2/Grid2"
import * as TEXT from "../../TextBaja"
import { UseDialogBajaContext } from "./DialogBajaContext"
import EditTerminationDate from "./EditTerminationDate"
import { TERMINATION } from "#constants/StatusRequest "
import { UseHasPermission } from "#hooks/useHasPermission"
import { PERFILES } from "#constants/Strings"

export default function InfoBajasDialog({ baja, notAll = false }) {
	const {
		perfil_puesto = "",
		no_empleado = "",
		name_collaborator = "",
		id,
		sucursal,
		termination_status,
		fecha_alta,
	} = baja || {}
	const { disabled } = UseDialogBajaContext()
	let info = [
		{ xs: 1, campo: "ID", valor: id },
		{ xs: 3, campo: "Sucursal", valor: sucursal },
		{ xs: 2, campo: TEXT.FECHA_ALTA, valor: fecha_alta },
		{
			xs: 4,
			campo: TEXT.NAME_COLLABORATOR,
			valor: `${no_empleado} ${name_collaborator}`,
		},
		{ xs: 6, campo: TEXT.PERFIL_PUESTO, valor: perfil_puesto },
		{ xs: 2, campo: TEXT.TERMINATION_STATUS, valor: termination_status },
	]
	if (disabled) return null
	return <InformationView data={info} />
}
export function InformationSolicitudBajas({ baja }) {
	const is_rh = UseHasPermission(PERFILES.RH)
	const {
		request_date,
		reason,
		name_request_collaborator,
		type,
		termination_date,
		termination_status,
		approval_date,
		termination_status_id,
	} = baja

	const notEdit =
		!is_rh ||
		termination_status_id === TERMINATION.FINALIZADA ||
		termination_status_id === TERMINATION.CANCELADA

	let info = [
		{
			xs: 4,
			campo: TEXT.NAME_REQUEST_COLLABORATOR,
			valor: name_request_collaborator,
		},
		{ xs: 4, campo: TEXT.TERMINATION_STATUS, valor: termination_status },
		{ xs: 4, campo: TEXT.TYPE_BAJA, valor: type },

		{ xs: 4, campo: TEXT.REQUEST_DATE, valor: request_date },
		{
			xs: 4,
			campo: TEXT.TERMINATION_DATE,
			valor: termination_date,
			customRender: notEdit ? null : (
				<EditTerminationDate id={baja.id} termination_date={termination_date} />
			),
		},
		{ xs: 4, campo: TEXT.APPROVAL_DATE, valor: approval_date },

		{ xs: 12, campo: TEXT.REASON, valor: reason },
	]

	return <InformationView data={info} />
}
export function InformationTracsaSolicitudBajas({ baja }) {
	const { termination_type_1, termination_type_2, termination_type_3 } = baja
	let info = [
		{ xs: 12, campo: TEXT.TYPE_1, valor: termination_type_1, noWrap: false },
		{ xs: 12, campo: TEXT.TYPE_2, valor: termination_type_2, noWrap: false },
		{ xs: 12, campo: TEXT.TYPE_3, valor: termination_type_3, noWrap: false },
	]
	return <InformationView data={info} />
}

function InformationView({ data }) {
	return (
		<Box>
			<Grid2 container spacing={2} >
				{data.map((item, index) => {
					let contenido = null
					if (item?.customRender) contenido = item.customRender
					else if (item.valor)
						contenido = <TextInfoField whiteSpace="pre-line" {...item} separador={"\n"} />
					else return null
					return (
						<Grid2 xs={item["xs"]} key={item.campo + index}>
							{contenido}
						</Grid2>
					)
				})}
			</Grid2>
		</Box>
	)
}
